var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',[_c('a-tab-pane',{key:"1",attrs:{"tab":"成绩录入设置"}},[_c('ScoreInputSetting')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"教师成绩录入"}},[_c('TeacherScoreInput')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }